import React from "react";
import { COMPANY } from "@/data/content";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="border-t border-[var(--owrs-border)] bg-[var(--owrs-bg)]"
    >
      <div className="container-owrs py-14 sm:py-16">
        <div className="grid grid-cols-2 gap-10">
          <div>
            <div className="overline mb-4">Workshop</div>
            <address className="not-italic text-sm sm:text-base text-[var(--owrs-text)] leading-relaxed">
              {COMPANY.addressLines.map((l) => (
                <div key={l}>{l}</div>
              ))}
            </address>
            <div className="text-xs sm:text-sm text-[var(--owrs-text-muted)] mt-4">
              {COMPANY.hours}
            </div>
          </div>

          <div className="text-right">
            <div className="overline mb-4">Direct</div>
            <a
              href={`tel:${COMPANY.phoneTel}`}
              className="block text-sm sm:text-base hover:text-[var(--owrs-accent)] transition-colors"
            >
              {COMPANY.phone}
            </a>
            <a
              href={`mailto:${COMPANY.email}`}
              className="block text-sm sm:text-base mt-2 hover:text-[var(--owrs-accent)] transition-colors break-all"
            >
              {COMPANY.email}
            </a>
          </div>
        </div>

        <div className="divider-line my-10" />

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[var(--owrs-text-dim)]">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="sm:text-right">
            Within easy reach of the M1, M69 and A5 · M40, M42 and M6 all within 45 minutes ·
            Under an hour from Silverstone.
          </div>
        </div>

        <div className="mt-6 text-[11px] text-[var(--owrs-text-dim)] leading-relaxed max-w-3xl">
          Information you submit through our contact and booking forms is stored securely
          and used solely to respond to your enquiry. We do not share your details with
          third parties. By using these forms you consent to OWRS Automotive Ltd contacting
          you in relation to your enquiry.
        </div>
      </div>
    </footer>
  );
}
